import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { UsageGuide, UsageGuideScope } from "../../productUsageGuides.types";

export const requestUsageGuideByScope = async (
  scope: UsageGuideScope
): Promise<UsageGuide | null> => {
  // Deliberately does not fall back to the category — this is the guide of
  // exactly this scope, which is what the editor has to open on.
  const guide: UsageGuide | "" | null = await instance.get(
    ApiRoutesProductUsageGuides.Guides,
    { params: scope }
  );

  // Nest sends an empty body rather than the literal `null` when there is no
  // guide, and axios surfaces that as "". Normalise so callers check one thing.
  return guide || null;
};
